import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Solicitação', flex: 1.5, orderValue: 'movementDate' },
  { title: 'Tipo', flex: 1, orderValue: 'movementType' },
  { title: 'Cliente', flex: 1.5, orderValue: 'clientName' },
  { title: 'Emissor', flex: 1.5, orderValue: 'issuerName' },
  { title: 'Ativo', flex: 1, orderValue: 'bondType' },
  { title: 'Taxa', flex: 1, orderValue: 'rateValue' },
  { title: 'Vencimento', flex: 1, orderValue: 'maturityDate' },
  { title: 'Valor', flex: 1, orderValue: 'financial' },
  { title: 'Status', flex: 1, orderValue: 'statusDescription' },
];
